<template>
    <a
        href="#"
        class="inline-flex items-center gap-3 text-sm font-medium text-white hover:text-[#C9A55A] transition-colors duration-200 group"
    >
        <!-- Gold pulse ring button -->
        <span class="relative flex h-10 w-10 items-center justify-center bg-white/10 animate-gold-pulse group-hover:bg-[#A07830]/20 transition-colors">
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" class="h-5 w-5">
                <path d="M9.5 14.382V9.618a.5.5 0 0 1 .724-.447l4.764 2.382a.5.5 0 0 1 0 .894l-4.764 2.382a.5.5 0 0 1-.724-.447Z"
                    fill="#A07830" stroke="#A07830"
                />
            </svg>
        </span>
        <span class="text-sm font-medium">Watch the video</span>
    </a>
</template>